import { useRef } from 'react';
import { useMount } from 'src/helpers/hooks/useMount';

export const useStickyDesktopPaymentSidebar = () => {
  const parentRef = useRef<HTMLDivElement>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);

  useMount(() => {
    const parent = parentRef.current;
    const sidebar = sidebarRef.current;

    if (!parent || !sidebar) return;

    /**
     * 32px is offset between sidebar and sticky header
     * 100px is the height of sticky header + padding (80px + 20px)
     */
    const topOffset = 32 + 100;

    sidebar.style.top = `${topOffset}px`;

    function onScroll() {
      if (!parent || !sidebar) return;

      const parentTop = parent.getBoundingClientRect().top;

      if (parentTop < topOffset) {
        sidebar.style.position = 'sticky';
      } else {
        sidebar.style.position = 'static';
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  });

  return { parentRef, sidebarRef };
};

export const useStickyTabPaymentSidebar = () => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  useMount(() => {
    const sidebar = sidebarRef.current;

    if (!sidebar) {
      return;
    }

    const topOffset = sidebar.getBoundingClientRect().top;

    sidebar.style.top = `${topOffset}px`;
  });

  return { sidebarRef };
};
